const asyncCancelErrorSymbol = Symbol.for('$$AsyncCancelError');
export class AsyncCancelError extends Error {
    constructor() {
        super(...arguments);
        this.cls = asyncCancelErrorSymbol;
    }
}
export function isAsyncCancelError(e) {
    return e instanceof AsyncCancelError || (e?.cls === asyncCancelErrorSymbol);
}
